module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/SM-29114fa398efcab3b24408edca83d142.png";